<div
  *ngIf="contract?.creationStep === 1; else contractSupportFunctionValidatedTemplate"
  class="flex flex-col w-full gap-6 mt-6"
  [formGroup]="form"
>
  <div class="flex flex-row-reverse gap-2">
    <button
      *ngIf="!isContractArchived"
      color="primary"
      mat-raised-button
      type="button"
      (click)="onSave()"
      [permissionBlock]="ENUM_PERMISSIONS.UPDATE_CONTRACT"
    >
      ENREGISTRER
    </button>
  </div>

  <div class="flex flex-row w-full gap-6">
    <div class="card w-full">
      <div class="flex flex-row px-gutter py-4 border-b">
        <h2 class="title m-0">Engagement générique</h2>
      </div>

      <div class="px-gutter py-4 flex flex-col gap-4">
        <base-form-input
          *ngIf="hasGenericEngagement"
          @fadeInRight
          [disabled]="hasGenericEngagement"
          appearance="outline"
          type="autocomplete"
          class="w-full"
          displayProperty="label"
          label="Engagement générique"
          controlName="genericEngagement"
        ></base-form-input>

        <base-form-input
          *ngIf="hasGenericEngagement"
          @fadeInRight
          [disabled]="hasGenericEngagement"
          appearance="outline"
          type="autocomplete"
          class="w-full"
          displayProperty="label"
          label="Établissement support"
          controlName="supportEstablishment"
        ></base-form-input>

        <base-form-input
          *ngIf="!hasGenericEngagement"
          [items$]="genericEngagement$"
          (autocompleteChange)="genericEngagementAutoCompleteChange.emit($event)"
          type="autocomplete"
          appearance="outline"
          class="w-full"
          displayProperty="label"
          label="Engagement générique"
          controlName="genericEngagement"
        ></base-form-input>

        <base-form-input
          @fadeInRight
          appearance="outline"
          class="w-full"
          label="Objet de l'engagement"
          controlName="object"
        ></base-form-input>

        <base-form-input
          @fadeInRight
          appearance="outline"
          class="w-full"
          label="Contact engagement"
          type="autocomplete"
          [items$]="engagementContacts$"
          (autocompleteChange)="engagementContactsAutoCompleteChange.emit($event)"
          displayProperty="fullName"
          controlName="engagementContact"
        ></base-form-input>
      </div>
    </div>
  </div>

  <div class="card w-full">
    <div class="flex flex-row px-gutter py-4 border-b">
      <h2 class="title m-0">Validité</h2>
    </div>
    <div class="px-gutter py-4 flex flex-col w-full gap-4">
      <div class="flex flex-row w-full gap-4">
        <base-form-input
          @fadeInRight
          appearance="outline"
          class="w-1/2"
          type="date"
          label="Date de début de validité"
          controlName="startValidityDate"
        ></base-form-input>

        <base-form-input
          @fadeInRight
          appearance="outline"
          class="w-1/2"
          type="date"
          label="Date de fin de validité"
          [minDate]="form.controls?.startValidityDate?.value"
          controlName="endValidityDate"
        ></base-form-input>
      </div>
    </div>
  </div>
</div>

<ng-template #contractSupportFunctionValidatedTemplate>
  <div class="flex flex-col w-full gap-6 mt-6" [formGroup]="form">
    <div class="flex flex-row-reverse gap-2">
      <button
        *ngIf="
          !(contract?.status === ContractStatusEnum.VALIDATED) &&
          !(contract?.status === ContractStatusEnum.EXPIRED) &&
          !isContractArchived
        "
        color="primary"
        mat-raised-button
        type="button"
        (click)="switchToUpdateMode.emit()"
        [permissionBlock]="ENUM_PERMISSIONS.UPDATE_CONTRACT"
      >
        MODIFIER
      </button>
    </div>

    <div class="flex flex-row w-full gap-6">
      <div class="card w-1/2">
        <div class="flex flex-row px-gutter py-4 border-b">
          <h2 class="title m-0">Engagement générique</h2>
        </div>

        <div class="px-gutter py-4 flex flex-col gap-4">
          <details-line-base
            hint="Engagement générique"
            [label]="contract?.genericEngagement?.label"
          ></details-line-base>
          <details-line-base
            hint="Établissement support"
            [label]="contract?.supportEstablishment?.label"
          ></details-line-base>

          <details-line-base hint="Objet de l'engagement" [label]="contract?.object"></details-line-base>

          <details-line-base
            *ngIf="!!contract?.quote"
            [label]="contract?.quote?.ticket?.technicalIdentifier"
            hint="Ticket"
            [link]="'/administrative/ticket/' + contract?.quote?.ticket?._id"
          ></details-line-base>

          <details-line-base
            hint="Contact engagement"
            [label]="contract?.engagementContact?.fullName"
          ></details-line-base>
        </div>
      </div>

      <div class="card w-1/2">
        <div class="flex flex-row justify-between px-gutter py-4 border-b">
          <h2 class="title m-0">Validité</h2>

          <!--                    <div *hasPermission="[ENUM_PERMISSIONS.UPDATE_CONTRACT]">-->
          <!--                        <button *ngIf="contract?.status === ContractStatusEnum.VALIDATED" color='primary'-->
          <!--                                mat-raised-button type='button' (click)="addDenunciationDate.emit()">AJOUTER UNE-->
          <!--                            DENONCIATION-->
          <!--                        </button>-->
          <!--                    </div>-->
        </div>

        <div class="px-gutter py-4 flex flex-col gap-4">
          <base-form-input
            [disabled]="!isUserCurrentEngagementContact"
            @fadeInRight
            appearance="outline"
            class="w-1/2"
            type="date"
            label="Date de début de validité"
            [maxDate]="form.controls?.endValidityDate?.value"
            controlName="startValidityDate"
          ></base-form-input>

          <base-form-input
            [disabled]="!isUserCurrentEngagementContact"
            @fadeInRight
            appearance="outline"
            class="w-1/2"
            type="date"
            label="Date de fin de validité"
            [minDate]="form.controls?.startValidityDate?.value"
            controlName="endValidityDate"
          ></base-form-input>
        </div>
      </div>
    </div>
  </div>
</ng-template>
